import Vue from "vue";
import VueRouter from "vue-router";
import Signin from "../views/Signin.vue";
import store from "../store";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Signin",
        component: Signin
    },
    {
        path: "/signup",
        name: "Signup",
        component: () =>
            import(/* webpackChunkName: "signup" */ "../views/Signup.vue")
    },
    {
        path: "/entries",
        name: "Entries",
        component: () =>
            import(/* webpackChunkName: "entries" */ "../views/Entries.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/entries/new",
        name: "New",
        component: () =>
            import(/* webpackChunkName: "new" */ "../views/New.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/entries/:filename",
        name: "View",
        component: () =>
            import(/* webpackChunkName: "view" */ "../views/View.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/entries/:filename/edit",
        name: "Edit",
        component: () =>
            import(/* webpackChunkName: "edit" */ "../views/Edit.vue"),
        meta: {
            requiresAuth: true
        }
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth && !store.state.user.loggedIn) {
        next({ path: "/", query: { redirected_from: to.fullPath } });
    } else {
        if (next.path !== "/" || next.path !== "/signup") {
            next();
        } else {
            next({ path: "/entries" });
        }
    }
});

export default router;
